import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'

export default {
  name: 'smartthon',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar
  },
  computed: {
    env () {
      return this.$store.getters.env
    },
    user () {
      return this.$store.getters.user
    }
  },
  data () {
    return {
      sidebar_tab: '2',
      smartthon: [],
      isModal: false,
      modalInfo: {},
      smartthon_key: '',
      loading: true,
      isError: false,
      message: ''
    }
  },
  mounted () {
    this.$apig.get(this.$store.getters.api.SMARTTHON, {}, {}, {})
      .then(response => {
        this.smartthon = response.data
        this.loading = false
      })
  },
  methods: {
    getCover (item) {
      return `${this.env.S3}/smartthon/${item.smartthonId}/cover/${item.coverId}.png`
    },
    openModal (item, key) {
      this.isModal = true
      this.modalInfo = item
      this.smartthon_key = key
    },
    deleteSmartthon (smartthonId) {
      this.isModal = false
      this.loading = true

      let pathParams = {
        smartthonId: this.modalInfo.smartthonId
      }

      let additionalParams = {
        queryParams: {
          type: 'delete'
        }
      }

      this.$apig.patch(this.$store.getters.api.SMARTTHON, pathParams, additionalParams, {})
        .then(() => {
          this.smartthon.splice(this.smartthon_key, 1)
          this.loading = false
        })
        .catch(err => {
          console.error(err)
          this.isError = true
          this.message = '一時的なエラーが発生しています。時間を置いてお試しください。'
          this.loading = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/smartthon/smartthon.js